// services/geolocationService.js
export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject("Geolocation is not supported by your browser.");
    }

    // Set a timeout to prevent hanging
    const timeoutId = setTimeout(() => {
      reject("Geolocation timeout");
    }, 5000);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId);
        const { latitude, longitude } = position.coords;
        resolve({ latitude, longitude });
      },
      (error) => {
        clearTimeout(timeoutId);
        reject("Unable to retrieve location. Please enable location services.");
      },
      {
        timeout: 5000,
        enableHighAccuracy: false,
        maximumAge: 60000,
      }
    );
  });
};
